export default __webpack_public_path__ + "static/media/V210_SOV.07176235.pdf";